import { useTranslation } from "react-i18next";
import { Badge, Button, Card, Form, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { IVectorizedBatchImageModel, modelNames, VectorizedStatus } from "../../types/vectorization";
import { Amplify, Storage } from "aws-amplify";
import aws_config from "../../aws-exports";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { downloadVectorizedImage } from "../../utils/fileUtil";
import { useLoadOptions } from "../../hooks/useLoadOptions";

interface IPix2PixImageProps {
    vectorizedImage: IVectorizedBatchImageModel;
    modelType: keyof typeof modelNames;
}

const Pix2PixImage: React.FC<IPix2PixImageProps> = ({ vectorizedImage, modelType }) => {
    const { t } = useTranslation();
    const [img, setImg] = useState<string | undefined>(undefined);
    const [selectedImageDisplay, setSelectedImageDisplay] = useState<boolean>(false);
    useEffect(() => {
        Storage.configure({
            aws_user_files_s3_bucket_region: aws_config.aws_user_files_s3_bucket_region,
            aws_user_files_s3_bucket: aws_config.vectorization_images_s3_bucket_name
        });

        const fetchImages = async () => {
            const config: any = { level: 'public', customPrefix: { public: '' } };

            try {
                const omeImg = await Storage.get(`outputs/${modelType}/${vectorizedImage.id}.png`, { ...config });
                setImg(omeImg);

            } catch (error) {
                console.error("Error fetching images", error);
            }
        };

        fetchImages();
    });


    return (
        <div className="position-relative pt-3">
            <div className="position-absolute z-1 vector-info-badge">
                <Badge bg="primary" className="stroke">
                    {modelNames[modelType]}
                </Badge>
            </div>
            <Card className="card-wrap-image">
                <Card.Body className="d-flex flex-column justify-content-center align-items-center gap-2">
                    <Card.Img
                        className={vectorizedImage.status === VectorizedStatus.COMPLETED ? "pointer-hover" : ""}
                        variant="top"
                        src={img}
                        alt={vectorizedImage.id}
                        onClick={() => setSelectedImageDisplay(true)}
                    />
                </Card.Body>
                {vectorizedImage.status === VectorizedStatus.COMPLETED && (
                    <Card.Footer className="d-flex flex-row gap-2 justify-content-center">
                        <Button
                            className="d-flex flex-row gap-1 align-items-baseline"
                            variant="secondary"
                            disabled={vectorizedImage.status !== VectorizedStatus.COMPLETED}
                            onClick={() => downloadVectorizedImage(img ?? '', vectorizedImage.id + ".png")}
                        >
                            {t("Vectorization.Download")}
                            <FontAwesomeIcon icon={faDownload} />
                        </Button>

                    </Card.Footer>
                )}

            </Card>
            <Modal show={selectedImageDisplay === true} onHide={() => setSelectedImageDisplay(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Image Preview")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={img} className="img-fluid" />
                </Modal.Body>
            </Modal>
        </div>


    );
};

export default Pix2PixImage;